export enum TableStatus {
  available = 0,
  reserved = 1,
  occupied = 2,
}
